import styled from "styled-components";

export const Container = styled.div`
  min-height: 100vh;
  max-width: 1000px;
`;

export const PaymentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  background: white;
  padding: 2rem;
  border-radius: 15px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
`;

export const DetailsSection = styled.div`
  flex: 2;
  min-width: 300px;
`;

export const PIXSection = styled.div`
  flex: 1;
  min-width: 300px;
  background-color: #f7fafc;
  padding: 1.5rem;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
`;

export const DetailItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }

  .ant-typography {
    margin-bottom: 0;
  }
`;
